import '@ungap/custom-elements'
import 'core-js'
import Vue from 'vue'
import App from './App.vue'
import VueCookie from 'vue-cookie'
import vueCustomElement from 'vue-custom-element'

Vue.config.productionTip = false

if (process.env.VUE_APP_NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.silent = true
}

// Vue.prototype.$http = axios

Vue.use(vueCustomElement)
App.VueCookie = VueCookie
Vue.customElement('nsd-cookie-banner', App)
